import {
    Mail,
    Phone,
    User,
    Calendar,
    MapPin,
    BadgeCheck,
} from "lucide-react";

import "./DeliveryProfileCard.css";
import getImageUrl from "../../../utils/imageUrl";
function DeliveryProfileCard({ partner }) {

    const statusClass = partner.work?.status?.toLowerCase() || "";

    return (

        <div className="delivery-profile-card">

            <div className="profile-header">

              <img
    src={
        partner.profile?.photo
            ? getImageUrl(partner.profile.photo)
            : "/images/default-user.png"
    }
    alt="Delivery Partner"
    className="profile-image"
    onError={(e) => {
        e.currentTarget.src = "/images/default-user.png";
    }}
/>
                <div className="profile-info">

                    <h2>{partner.userId?.name}</h2>

                    <span className={`status-badge ${statusClass}`}>
                        <BadgeCheck size={16} />
                        {partner.work?.status || "Unknown"}
                    </span>

                </div>

            </div>

            <div className="profile-details">

                <div className="detail-item">

                    <Mail size={18} />

                    <span>{partner.userId?.email || "-"}</span>

                </div>

                <div className="detail-item">

                    <Phone size={18} />

                    <span>{partner.userId?.phone || "-"}</span>

                </div>

                <div className="detail-item">

                    <User size={18} />

                    <span>{partner.profile?.gender || "-"}</span>

                </div>

                <div className="detail-item">

                    <Calendar size={18} />

                    <span>{partner.profile?.dob || "-"}</span>

                </div>

                <div className="detail-item">

                    <MapPin size={18} />

                    <span>
                        {[
                            partner.address?.address,
                            partner.address?.area,
                            partner.address?.city,
                            partner.address?.state,
                            partner.address?.pincode,
                        ]
                            .filter(Boolean)
                            .join(", ") || "-"}
                    </span>

                </div>

            </div>

        </div>

    );

}

export default DeliveryProfileCard;